import analyticsTrack from '@lib/analytics/analyticsTrack';
import { hashCode } from '@lib/string';
import classNames from 'classnames';
import React from 'react';
import { MERCH_GROUP_URL_PREFIX } from '@components/shared/shop/model/MerchGroup';
import _ from 'lodash';
import { IShopNavigationMenuItem, IShopNavigationMenuItemOptions } from '../model';
import styles from './MenuDropDownList.module.scss';

interface IMenuDropDownListProps {
  navItem: IShopNavigationMenuItem;
  navOption: IShopNavigationMenuItemOptions;
  className?: string;
}

const COLUMN_ITEM_LIMIT = 8;

const MenuDropDownList = ({
  navItem,
  navOption,
  className = undefined
}: IMenuDropDownListProps) => {
  const columns = _.range(0, Math.ceil(navItem.children.length / COLUMN_ITEM_LIMIT));
  return (
    <div className={classNames(
      styles.DropDownListWrapper,
      className
    )}
    >
      <ul className={styles.DropDownList}>
        {
          columns.map((column) => {
            const startIdx = column * COLUMN_ITEM_LIMIT;
            const endIdx = startIdx + COLUMN_ITEM_LIMIT;
            return (
              <div className={styles.Column} key={`${navItem.slug}-${column}`}>
                {
                  navItem.children.slice(startIdx, endIdx).map((child) => {
                    const { title, slug } = child;
                    const childType = '__typename' in child ? (child as any).__typename : 'unknown';
                    return (
                      <li
                        key={hashCode(title)}
                        className={styles.DropDownMenuItem}
                      >
                        <a
                          href={childType === 'MerchGroupModel' ?
                            `${MERCH_GROUP_URL_PREFIX}/${slug}` :
                            `/shop/${slug}`}
                          onClick={() => {
                            analyticsTrack('shop_nav_item_clicked', {
                              title: `Shop Navigation Menu | ${navItem.title} | ${title}`,
                              ctaUrl: navOption.image1_cta_link,
                              image: navOption.image1
                            });
                          }}
                        >
                          {title}
                        </a>
                      </li>
                    );
                  })
                }
              </div>
            );
          })
        }
      </ul>
    </div>
  );
};

export default MenuDropDownList;
